import { useMutation } from '@tanstack/react-query';

import { createCustomTaskWithoutThunk } from '@entities/task/api/createCustomTask';

export const useCreateCustomTaskQuery = (onSuccessCb?: () => void) =>
    useMutation({
        mutationKey: ['createTask'],
        mutationFn: createCustomTaskWithoutThunk,
        onSuccess: (res) => {
            if (res.status === 'success') {
                onSuccessCb?.();
            }
        },
    });
